import * as React from "react";
import Modal from "../../ui/modal/Modal";
import SectionSeparator from "../../layout/section/SectionSeparator";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface Props {
	closeModal: () => void
	navigateToBill: () => void
}

export default class PartnerBrandOutstandingBillsWarningModal extends React.PureComponent<Props> {

	render() {
		return (
			<Modal title={"Please note!"} mediumWidth>
				<div className={"a-text-blue"}>There are one or more bills outstanding for this Partner Brand.</div>
				<SectionSeparator style={{margin: "20px 0"}}/>
				<ButtonGroupWrapper isRight={true}>
					<ButtonSecondary label={"Cancel"} onClick={this.props.closeModal}/>
					<ButtonPrimary label={"Continue to Bill of Materials"} onClick={this.props.navigateToBill}/>
				</ButtonGroupWrapper>
			</Modal>)
	}
}